<template>
  <div>
    <v-row>
      <v-col md="4">
        <v-card class="elevation-0" outlined>
          <v-card-title>
            Orden
          </v-card-title>
          <v-card-text>
            <v-row class="text-center" v-if="productosSeleccionados.length == 0">
              <v-col cols="12">
                <v-icon x-large>mdi-cart</v-icon>
              </v-col>
              <v-col cols="12">
                <p class="caption grey--text">La orden se encuentra vacía.</p>
              </v-col>
            </v-row>
            <div v-for="(item, index) in productosSeleccionados" :key="index">
              <v-row class="mb-1">
                <v-col sm="6" class="title"><span v-if="item.tipo == 'Topings'">*</span>{{item.nombre}}</v-col>
                <v-col sm="4" class="title">${{item.precio}}</v-col>
                <v-col sm="2">
                  <v-btn icon @click="removeProducto(item, index)">
                    <v-icon>delete</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-row class="ma-2">
            <span class="title">Total</span>
            <v-spacer></v-spacer>
            <span class="title">${{total}}</span>
          </v-row>
          <v-card-actions v-if="productosSeleccionados.length > 0">
            <v-btn block dark @click="checkout">Ordenar</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col md="8" v-if="mainMenu">
        <v-row>
          <v-col class="py-0 mb-4" md="3" v-for="(item, index) in items" :key="index">
            <v-card v-ripple outline>
              <v-list-item @click="selectItem(item.text)">
                <v-list-item-icon>
                  <v-icon large>{{item.icon}}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{item.text}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col md="8" v-if="bebidasMenu">
        <v-card class="elevation-0">
          <v-card-title>
            <v-btn icon @click="backMainMenu">
              <v-icon x-large>mdi-arrow-left-circle</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <p class="text-center title">{{currentMenuTitle}}</p>
            <v-row v-if="loadingProductos">
              <v-col sm="12" class="text-center">
                <v-progress-circular
                  :size="70"
                  :width="7"
                  color="black"
                  indeterminate
                ></v-progress-circular>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col class="py-0 mb-4" md="3" v-for="(item, index) in productos" :key="index">
                <v-card v-ripple outline @click="selectMenuItem(item)">
                  <v-card-title>
                    {{item.nombre}}
                  </v-card-title>
                  <v-card-text>
                   ${{item.precio}}
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row v-if="productos.length == 0 && !loadingProductos">
              <v-col sm="12">
                <p class="caption">No se encontraron resultados.</p>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog
      v-model="topingsDialog"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title>
          Toppings
        </v-card-title>
        <v-card-text>
            <v-row v-if="loadingTopings">
              <v-col sm="12" class="text-center">
                <v-progress-circular
                  :size="70"
                  :width="7"
                  color="black"
                  indeterminate
                ></v-progress-circular>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col class="py-0 mb-4" md="3" v-for="(item, index) in topings" :key="index">
                <v-card v-ripple outline @click="selectMenuItem(item)">
                  <v-card-title>
                    {{item.nombre}}
                  </v-card-title>
                  <v-card-text>
                   ${{item.precio}}
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row v-if="topings.length == 0 && !loadingTopings">
              <v-col sm="12">
                <p class="caption">No se encontraron resultados.</p>
              </v-col>
            </v-row>
          </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="topingsDialog = false">Listo<v-icon right>mdi-check</v-icon></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import functions from '@/mixins/functions'
import Loader from '../components/Loader'

export default {
    name: 'Menu',
    components: {
        Loader
    },
    mixins: [
        functions
    ],
    data() {
      return {
        tab: null,
        items: [
          { text: 'Bebidas', icon: 'mdi-glass-mug-variant' },
          { text: 'Pizzas', icon: 'local_pizza' },
          { text: 'Pastas', icon: 'mdi-pasta' },
          { text: 'Ensaladas', icon: 'mdi-food-variant' },
          { text: 'Botanas', icon: 'mdi-food-croissant' },
          { text: 'Postres', icon: 'cake' },
        ],
        mainMenu: true,
        bebidasMenu: false,
        currentMenuTitle: '',
        productos: [],
        loadingProductos: false,
        productosSeleccionados: [],
        total: 0,
        topingsDialog: false,
        topings: [],
        loadingTopings: false
      }
    },
    methods: {
      selectItem(item) {
        //console.log(item)
        this.mainMenu = false
        this.bebidasMenu = true
        this.loadingProductos = true
        this.currentMenuTitle = item

        axios.get(this.$store.state.astilleroURL + '/api/views/services_productos?display_id=services_1&args[0]=' + item, {
          headers: {
            'Content-Type': 'application/json',
            'X-Cookie': this.$store.state.user.session_name + '=' + this.$store.state.user.sessid,
            'X-CSRF-Token': this.$store.state.token
          }
        })
        .then(res => {
          //console.log(res.data)
          this.loadingProductos = false
          this.productos = res.data
        })
        .catch(error => console.log(error))
      },
      backMainMenu() {
        this.mainMenu = true
        this.bebidasMenu = false
      },
      selectMenuItem(item) {
        console.log(item)
        this.productosSeleccionados.push(item)
        this.total += Number(item.precio)
        this.$store.commit('setSelectedProducts', item)
        if(item.tipo == 'Pizzas') {
          this.loadingTopings = true
          this.loadMenuItemsByName('Topings')
          .then(res => {
            this.loadingTopings = false
            console.log(res)
            this.topings = res
          })
          this.topingsDialog = true
        }
      },
      removeProducto(item, currentIndex) {
        this.productosSeleccionados = this.productosSeleccionados.filter((i, index) => index != currentIndex)
        this.total = this.total - Number(item.precio)
        this.$store.commit('removeProduct', currentIndex)
        this.$store.commit('updatePrice', Number(item.precio))
      },
      loadMenuItemsByName(name) {
        return axios.get(this.$store.state.astilleroURL + '/api/views/services_productos?display_id=services_1&args[0]=' + name, {
          headers: {
            'Content-Type': 'application/json',
            'X-Cookie': this.$store.state.user.session_name + '=' + this.$store.state.user.sessid,
            'X-CSRF-Token': this.$store.state.token
          }
        })
        .then(res => res.data)
        .catch(error => console.log(error))
      },
      checkout() {
        this.$emit('checkout')
      }
    }
}
</script>

<style>

</style>